import React from "react";
import { useTranslation } from "react-i18next";
import { TransformedProduct } from "../../../../product/types/productApiTypes";
import ProductPriceDisplay from "../../../../product/components/common/ProductPriceDisplay";
import type { CompareRowConfig } from "./CompareTable";

interface CompareDataCellProps {
  row: CompareRowConfig;
  product: TransformedProduct;
}

const CompareDataCell: React.FC<CompareDataCellProps> = ({ row, product }) => {
  const { t } = useTranslation();
  const isOutOfStock = product.stockStatus === "outofstock";

  const renderContent = () => {
    switch (row.key) {
      case "price":
        return <ProductPriceDisplay product={product} />;

      case "availability":
        return (
          <span
            className={`stock-badge ${
              isOutOfStock ? "is-out-of-stock" : "is-in-stock"
            }`}
          >
            {isOutOfStock
              ? t("productCard.outOfStockBadge", "Sold Out")
              : t("productInfoDetails.inStock", "In Stock")}
          </span>
        );

      case "description":
        return (
          <div
            className="compare-cell__description-content"
            dangerouslySetInnerHTML={{ __html: product.shortDescription }}
          />
        );

      default:
        // Attribute handling
        if (row.type === "attribute") {
          const attr = product.enrichedAttributes.find(
            (a) => a.taxonomy === row.key
          );
          return attr ? attr.terms.map((t) => t.name).join(", ") : "—";
        }
        return "—";
    }
  };

  return (
    <div
      className={`compare-cell__inner compare-cell__inner--${row.key.replace(
        "pa_",
        ""
      )} ${row.key === "description" ? "compare-cell__inner--description" : ""}`}
    >
      {/* Mobile Label */}
      <span className="compare-cell__mobile-label">{row.label}</span>
      <div className="compare-cell__content">{renderContent()}</div>
    </div>
  );
};

export default CompareDataCell;
